// extracted by mini-css-extract-plugin
module.exports = {"DeliveryOrderButtons":"DeliveryOrderButtons_DeliveryOrderButtons__1SHSI"};